import Button from "@/components/ui/Button";
import { Heading } from "@/components/ui/Typography";
import { useState } from "react"
import { useNavigate } from "react-router-dom";


const TemplatePreviewCard = ({ template, readOnly }:{template: { id: string; image: string; name: string; } | undefined, readOnly?: boolean}) => {
  const navigate = useNavigate();

  const [showMenu, setShowMenu] = useState<boolean>(false);

  if (!template) {
    return null;
  }

  return (
     <div 
                    onMouseEnter={()=>{
                      if(!readOnly) {
                        setShowMenu(true)
                      }
                    }} 
                    onMouseLeave={()=>{
                      if(!readOnly) {
                        setShowMenu(false)
                      }
                    }}
                     className=" flex flex-col gap-4   transition-shadow duration-200 lg:gap-4">
                      <div className="relative overflow-hidden w-full h-full flex flex-col items-center justify-center cursor-pointer rounded-lg" style={{boxShadow: "0px 4px 20px 0px #00000014"
    }}>
                           <img src={template.image} alt={template.name} className="w-full h-full object-cover rounded-lg overflow-hidden"  />
                      {showMenu  && (
                        <div className="absolute z-10 bg-[#000000] opacity-[0.26] h-full w-full">
                       
    
                      </div>
                      )}
                      {showMenu  && (
                        <div className="absolute z-20 h-full gap-3 flex flex-col items-center justify-center w-full p-4">
                          <Button onClick={()=>{
                            navigate("?subSection=microsite&action=edit&templateId="+template.id)
                          }} className="min-w-48">Use microsite</Button>
                          <Button onClick={()=>{
                            const url = `?subSection=microsite&action=preview&templateId=${encodeURIComponent(template.id)}`;
window.open(url, '_blank');
                          
                          }} className="min-w-48" variant="secondary">Preview microsite</Button>
    
                      </div>
                      )}
                      </div>
                   
                      <div className="flex flex-col ">
                        <Heading level={4} className="">{template.name}</Heading>                       
                      </div>
                    </div>
  )
}

export default TemplatePreviewCard